import React, { createContext, useState, useEffect } from 'react';
import isUndefined from 'lodash.isundefined';
import PropTypes from 'prop-types';
import useViewer from '@hooks/useViewer';

export const MembershipContext = createContext();

const flowTypes = {
    MEMBERSHIP: 'membership',
    REGISTRATION: 'registration',
};

const companyTypes = {
    NEW: 'new',
    EXISTING: 'existing',
    INDEPENDENT: 'independent',
};

const joinSteps = {
    SEARCH_EMAIL: 'email',
    SEARCH_NAME: 'name',
    LOGIN: 'login',
    WHO_FOR: 'whoFor',
};

const searchStatuses = {
    EMAIL_NOT_FOUND: 'emailNotFound',
    NAME_NOT_FOUND: 'nameNotFound',
    LOGIN: 'login',
};

const MembershipProvider = ({ children }) => {
    const [matchResultsByCompanyAndEmail, setMatchResultsByCompanyAndEmail] = useState();
    const [matchResultsByName, setMatchResultsByName] = useState();
    const [matchResultsRejected, setMatchResultsRejected] = useState();
    const [membershipFor, setMembershipFor] = useState([]);
    const [companyType, setCompanyType] = useState('');
    const [nameMatchResults, setNameMatchResults] = useState();
    const [searchStatus, setSearchStatus] = useState('');
    const [joinStep, setJoinStep] = useState();
    const [isEmailValid, setIsEmailValid] = useState(false);
    const [user, setUser] = useState({});
    const { viewer } = useViewer();

    useEffect(() => {
        if (isUndefined(viewer)) {
            return;
        }

        if (viewer) {
            setJoinStep(joinSteps.WHO_FOR);
        } else {
            setJoinStep(joinSteps.SEARCH_EMAIL);
        }
    }, [viewer]);

    if (isUndefined(viewer) || !joinStep) {
        return null;
    }

    return (
        <MembershipContext.Provider
            value={{
                companyType,
                companyTypes,
                flowTypes,
                isEmailValid,
                joinStep,
                joinSteps,
                matchResultsByCompanyAndEmail,
                matchResultsByName,
                matchResultsRejected,
                membershipFor,
                nameMatchResults,
                searchStatus,
                searchStatuses,
                user,
                setCompanyType,
                setIsEmailValid,
                setMatchResultsByCompanyAndEmail,
                setMatchResultsByName,
                setMatchResultsRejected,
                setMembershipFor,
                setNameMatchResults,
                setSearchStatus,
                setJoinStep,
                setUser,
            }}
        >
            {children}
        </MembershipContext.Provider>
    );
};

MembershipProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export default MembershipProvider;
